import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import Widget from '../../../../common/js/Widget.js';

export default class LoginWidget extends Widget {

	constructor($widget) {
		super($widget);

		Form.onSubmit($widget, action => {
			Ajax.rpc('/login', {
				user: action.findField('user').val(),
				password: action.findField('password').val(),
				remember: !!action.findField('remember').is(':checked')
			}, success => {
				if (success) {
					window.location.href = '/';
				} else {
					action.error('Ungültiger Name oder falsches Passwort');
				}
			}, error => {
				action.error('Login fehlgeschlagen', error);
			});
		});
	}

}
